<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsInstituicaoCursoSuperior"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsInstituicaoCursoSuperior"
          addFilter
          :items="listarCursoSuperior"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editCursoSuperior"
      size="lg"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="instituicao.id === 0 ? addInstituicao() : editandoInstituicao()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-6">
            <fccInput extraClasses="inputLabel" v-model="instituicao.codocde" required
              >CODOCDE</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="instituicao.descricao" required
              >Curso
            </fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <fcc-select
              class="mb-4"
              placeholder="Selecione"
              valueField="id"
              v-model="instituicao.idareadetalhada"
              :options="listarAreaDetalhada"
              required
            >
              Área Detalhada
            </fcc-select>
          </div>
          <div class="col-sm-6">
            <fcc-select
              valueField="id"
              class="mb-4"
              placeholder="Selecione"
              v-model="instituicao.idareaespecifica"
              :options="lstAreaEspecifica"
              required
            >
              Área Específica
            </fcc-select>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <fcc-select
              class="mb-4"
              placeholder="Selecione"
              valueField="id"
              v-model="instituicao.idareaformacao"
              :options="listarAreaDetalhada"
              required
            >
              Área Formação
            </fcc-select>
          </div>
        </div>

        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Curso Superior',
      titleModal: '',
      titlePDF: 'Curso Superior',
      listarCursoSuperior: [],
      listarEscolaridade: [],
      lstAreaEspecifica: [],
      listarAreaFormacao: [],
      listarAreaDetalhada: [],
      baseUrlGestaoProjetosConcurso: '',
      instituicao: [],
      itemPorPage: '100',

      actionsInstituicaoCursoSuperior: [
        {
          button: true,
          funcaoButton: 'editCursoSuperior',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteCursoSuperior',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsInstituicaoCursoSuperior: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'codocde', label: 'Código', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    listandoAreaDetalhada() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.linstandoAreaDetalhadaGenerico()
        .then((response) => {
          this.listarAreaDetalhada = response
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoAreaEspecifica() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listandoAreaEspecificaGenerico()
        .then((response) => {
          this.lstAreaEspecifica = response
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoAreaFormacao: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'AreaFormacao/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarAreaFormacao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoCursoSuperior() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'CursoSuperior/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarCursoSuperior = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField() {
      this.titleModal = 'Adicionar instituição'
      this.instituicao = {}
      this.instituicao.id = 0
      this.$root.$emit('bv::show::modal', 'editCursoSuperior')
    },
    editCursoSuperior(_, item) {
      this.titleModal = 'Editar instituição'
      this.instituicao = { ...item }
      this.$root.$emit('bv::show::modal', 'editCursoSuperior')
    },
    editandoInstituicao() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'CursoSuperior/Alterar',
          this.instituicao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoCursoSuperior()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editCursoSuperior')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addInstituicao() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'CursoSuperior/Adicionar',
          this.instituicao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoCursoSuperior()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editCursoSuperior')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteCursoSuperior(_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'CursoSuperior/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoCursoSuperior()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted() {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.listandoCursoSuperior()
    this.listandoAreaDetalhada()
    this.listandoAreaEspecifica()
    this.listandoAreaFormacao()
  }
}
</script>
